export const ADD_PARENT_CONTACT_CLICKED = 'add_parent_contact_clicked';
export const PARENT_OTP_REQUESTED = 'parent_otp_requested';
export const PARENT_OTP_SUBMITTED = 'parent_otp_submitted';
export const PARENT_OTP_INVALID = 'parent_otp_invalid';
export const PARENT_CONTACT_ADDED = 'parent_contact_added';
export const EDIT_PARENT_CONTACT_CLICKED = 'edit_parent_contact_clicked';
export const PARENT_CONTACT_UPDATED = 'parent_contact_updated';
